import React, { useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from '../apiConfig';
import CryptoJS from 'crypto-js';

const DowntList = ({ match }) => {
  const down_userid = match.params.userid;
  const secretKey = 'Maxx12#';
  let history = useHistory();

  const [data, setData] = useState([]);
  const [totalUser, setTotalUser] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [limit, setLimit] = useState(10);
  const [pageCount, setPageCount] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const currentPage = useRef(1);

  const encryptUserId = (userId) => {
    const encrypted = CryptoJS.AES.encrypt(userId, secretKey).toString();
    return encrypted
      .replace(/\//g, '_')
      .replace(/\+/g, '-')
      .replace(/=/g, '');
  };

  useEffect(() => {
    currentPage.current = 1;
    getPaginatedUsers();
  }, [searchQuery, limit]);

  const getPaginatedUsers = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(
        `${apiConfig.baseURL}/api/agent/downLineView?page=${currentPage.current}&limit=${limit}&down_userid=${down_userid}&search=${searchQuery}`,
        { method: "GET" }
      );

      if (!res.ok) {
        if (res.status === 400) alert("Error 400: User ID is invalid.");
        return;
      }

      const data = await res.json();
      setPageCount(data.pageCount);
      setTotalUser(data.totalUser);
      setData(data.result || []);
    } catch (error) {
      console.error("An unexpected error occurred:", error);
    }
    setIsLoading(false);
  };

  const handleSearch = () => {
    currentPage.current = 1;
    setSearchQuery(searchInput);
  };

  const handleClearSearch = () => {
    setSearchInput('');
    setSearchQuery('');
    currentPage.current = 1;
  };

  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  };

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0 2rem;
    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
      margin: 0 5px;
    }
    li.active a { background-color: #0366d6; border-color: transparent; color: white; min-width: 32px; }
    li.disabled a { color: grey; }
    li.disable, li.disabled a { cursor: default; }
  `;

  return (
    <>
      <Navbar /><Chatbox /><HeaderRight /><LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">

              <div className="card-header d-flex flex-wrap align-items-center justify-content-between gap-2">
                <h4 className="card-title mb-0">
                  Downline List
                  <span className="badge badge-info ms-2" style={{ fontSize: '13px' }}>
                    {totalUser} users
                  </span>
                </h4>

                <div className="d-flex align-items-center gap-2 flex-wrap">

                  {/* Per page */}
                  <select
                    className="form-control form-control-sm"
                    style={{ width: 'auto' }}
                    value={limit}
                    onChange={e => { setLimit(e.target.value); currentPage.current = 1; }}
                  >
                    <option value="10">10 / page</option>
                    <option value="30">30 / page</option>
                    <option value="100">100 / page</option>
                    <option value="200">200 / page</option>
                  </select>

                  {/* Search */}
                  <div className="input-group input-group-sm" style={{ width: '280px' }}>
                    <input
                      type="text"
                      placeholder="Search user_id, name, mobile..."
                      className="form-control"
                      value={searchInput}
                      onChange={e => setSearchInput(e.target.value)}
                      onKeyDown={e => e.key === 'Enter' && handleSearch()}
                    />
                    {searchInput && (
                      <button className="btn btn-outline-secondary" onClick={handleClearSearch}>✕</button>
                    )}
                    <button className="btn btn-primary" onClick={handleSearch}>Search</button>
                  </div>
                </div>
              </div>

              {/* Active search indicator */}
              {searchQuery && (
                <div className="px-4 py-2" style={{ fontSize: '12px', color: '#f59e0b' }}>
                  🔍 Searching: <strong>"{searchQuery}"</strong> —
                  <span className="text-muted ms-1">{totalUser} results</span>
                  <button className="btn btn-link btn-sm p-0 ms-2 text-danger" onClick={handleClearSearch}>
                    Clear
                  </button>
                </div>
              )}

              <div className="card-body">
                <div className="table-responsive">
                  {isLoading ? (
                    <div className="text-center py-4 text-muted">Loading...</div>
                  ) : (
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>User ID</th>
                          <th>Name</th>
                          <th>Balance</th>
                          <th>Mobile</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length === 0 ? (
                          <tr>
                            <td colSpan="7" className="text-center py-4 text-muted">
                              No users found
                            </td>
                          </tr>
                        ) : (
                          data.map((element, id) => {
                            const encryptedUserId = encryptUserId(element.user_id);
                            return (
                              <tr key={element._id}>
                             
                                <td className="text-muted" style={{ fontSize: '12px' }}>
                                  {(currentPage.current - 1) * limit + id + 1}
                                </td>
                              
                                <td>
                                  <Link target="_blank" className="btn btn-white btn-sm" to={`/down-list/${encryptedUserId}`}>
                                    <strong>{element.user_id}</strong> 
                                  </Link>
                                </td>

                                <td>
                                  {element.first_name} {element.last_name}
                                  <small className="text-muted d-block">{element.handle}</small>
                                </td>
                                <td>
                                  <span className={`badge ${parseFloat(element.currency) > 0 ? 'badge-success' : 'badge-light'}`}>
                                    ৳{parseFloat(element.currency || 0).toFixed(2)}
                                  </span>
                                </td>
                                <td><small>{element.mobile}</small></td>
                                <td>
                                  <span className={`badge ${element.account_status === '2' ? 'badge-danger' : 'badge-success'}`}>
                                    {element.account_status === '2' ? 'Blocked' : 'Active'}
                                  </span>
                                </td>
                                <td>
                                  <div className="d-flex gap-1">
                                    <Link
                                      target="_blank"
                                      title="View Downline"
                                      className="btn btn-info shadow btn-xs sharp"
                                      to={`/down-list/${encryptedUserId}`}
                                    >
                                      <i className="fa fa-user"></i>
                                    </Link>
                                    <Link
                                      title="Edit"
                                      className="btn btn-warning shadow btn-xs sharp"
                                      to={`/edit-super-agent/${element._id}`}
                                    >
                                      <i className="fa fa-pencil"></i>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  )}

                  <MyPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={10}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    marginPagesDisplayed={2}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    forcePage={currentPage.current - 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DowntList;